export const adaptAlergia = (alergia) => {
    return {
        id: alergia?.idAlergia,
        displayName: alergia?.descripcion
    }
}

export const adaptAlergiaArray = (
    alergias
) => {
    return structuredClone(alergias?.allAlergias)
        ?.map(alergia => adaptAlergia(alergia));
}